import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [], // Each item will now have its own `quantity`
};

const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    addItem: (state, action) => {
      const existingItem = state.items.find(item => item.id === action.payload.id);
      if (existingItem) {
        existingItem.quantity += 1; // Increase quantity if item exists
      } else {
        state.items.push({ ...action.payload, quantity: 1 }); // New item starts with quantity 1
      }
    },
    removeItem: (state, action) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    },
    inceament: (state, action) => {
      const item = state.items.find(item => item.id === action.payload);
      if (item) item.quantity += 1;
    },
    deceament: (state, action) => {
      const item = state.items.find(item => item.id === action.payload);
      if (item && item.quantity > 1) item.quantity -= 1; // Prevent going below 1
    },
  },
});

export const { addItem, removeItem, inceament, deceament } = pageSlice.actions;
export default pageSlice.reducer;
